import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, countries, deepClone, ensureFullURL, generateCircleDot, isValidURL, isValidURL_adv } from '../utils'
import Loading from './Loading'
import { useDispatch, useSelector } from 'react-redux'
import { db } from '../firebase'
import { doc, updateDoc } from 'firebase/firestore'
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { redNex } from '../Redux/nexSlice'
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';


function BingSearch({ nexListn, _nex }) {
    const [data, setData] = useState([{data: [], siteRank: null}])
    const [url, setUrl] = useState('')
    const [prevUrl, setPrevUrl] = useState('')
    const [searchTerm, setSearchTerm] = useState('')
    const [location, setLocation] = useState('')

    const [isLoading, setIsLoading] = useState(false)
    const [showInfo, setShowInfo] = useState(false);

    const [noInput1, setNoInput1] = useState(false)
    const [noInput2, setNoInput2] = useState(false)
    const [noInput3, setNoInput3] = useState(false)

    const [noData, setNoData] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()

    const getData = async () => {
        if(searchTerm !== '' && location !== '') {
          if(url.trim() !== '') {
            if(isValidURL_adv(url)) {
              setPrevUrl(url)
            } else {
              setNoInput1(true)
              return
            }
          }
          setNoInput1(false)
          setNoInput2(false)
          setNoInput3(false)

          setNoData(false)


          // const updateAnalytics = async ()=> {
          //   const tool = 'bing-serp'
          //   let tools = deepClone(user.analytics.toolsUsage)
    
          //   if(tools['bing-search']) {
          //     tools[tool] = tools['bing-search']+= 1
          //     delete tools['bing-search']
          //   } else {
          //     tools[tool]+= 1
          //   }
            
          //   await updateDoc(doc(db, 'users', user.id), {analytics: {toolsUsage:tools}})
          // }

          const updateAnalytics = async () => {
            const tool = 'bing-serp';
            let tools = deepClone(user.analytics.toolsUsage);
        
            // Check if 'bing-search' exists and is valid
            if (isNaN(tools['bing-search']) || tools['bing-search'] == 'NaN') {
                // If 'bing-search' is NaN or doesn't exist, initialize it
                tools['bing-search'] = 1;
            } else {
                // If 'bing-search' exists and is valid, increment it
                tools['bing-search'] = Number(tools['bing-search']) + 1;
            }
        
            // Update 'bing-serp' with the incremented 'bing-search' value
            tools[tool] = tools['bing-search'];
        
            // Remove 'bing-search' from the object
            delete tools['bing-search'];
        
            // Save the updated tools usage back to Firestore
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };
        

          setPrevUrl(url)
          setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'bs',
                url: url.trim() === ''? 'example.com': url,
                searchTerm: searchTerm,
                location: location,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
                const sortedData = [...data[0].data].sort((a, b) => {
                    if (a.rank === 'na') return 1;
                    if (b.rank === 'na') return -1;
                    return a.rank - b.rank;
                })
              setData([{
                data: sortedData,
                siteRank: sortedData[0].siteRank
            }])
            setIsLoading(false)
            dispatch(redNex(nx))
            updateAnalytics()
            })
          } else {
            // if(url.trim() === '') setNoInput1(true)
            if(searchTerm.trim() === '') setNoInput2(true)
            if(location.trim() === '') setNoInput3(true)
          }
    }


    const toggleInfo = () => {
      setShowInfo(!showInfo);
  };

  
  useEffect(()=> {
    let timeoutId
    if(isLoading) {
      timeoutId = setTimeout(()=> {
        setIsLoading(false)
        setNoData(true)
      }, 20000)
    }

    return () => clearTimeout(timeoutId)
  }, [isLoading])


  return (
    <BingSearchContainer>
        <BingSearchInputContainer>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <h2>Bing SERP <span style={{fontSize: 'medium'}}>Organic results only - no ads</span>
            {false && <button onClick={toggleInfo} style={{ marginLeft: '10px', cursor: 'pointer', border: 'none', background: 'none', outline: 'none' }}>
                    {showInfo ? <RemoveIcon style={{color: 'var(--se-color)'}}/> : <AddIcon style={{color: 'var(--se-color)'}}/>}
                </button>}
            </h2>
            {showInfo && (
                <HeaderSpan>
                    <u>One use of this tool</u> is viewing top SERPs for any keyword by location on Bing to determine the required domain and page authority to rank.
                </HeaderSpan>
            )}</div>
            <BingSearchInputInnerContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Enter URL to see ranking (optional)</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Search Term or Keyword</label><input type='text' placeholder='coffee shops near me' style={{marginLeft: '20px', borderColor: noInput2? 'red': ''}} value={searchTerm} onChange={e=> setSearchTerm(e.target.value)}/></div>
                <select name="country" value={location} onChange={e=> setLocation(e.target.value)} className='select-country' style={noInput3? {borderColor: 'red'}: {}}>
                    {countries()}
                </select>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
                {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </BingSearchInputInnerContainer>
        </BingSearchInputContainer>

        {data[0]?.data.length !== 0 && !isLoading && !noData && <BingSearchResContainer>
            <BingSearchRes>
                        <p style={{width: '20px', fontSize: 'medium', fontFamily: 'Quicksand'}}>Rank</p>
                        <div><div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}><span style={{marginLeft: '7px', fontFamily: 'Quicksand'}}>Website</span></div><span style={{color: 'green', fontSize: 'small'}}></span><span style={{color: 'gray', fontSize: 'small'}}></span></div>
                        <p style={{marginLeft: '30px', width: '200px', fontSize: 'medium', fontFamily: 'Quicksand'}}>Page Authority</p>
                        <p style={{marginLeft: '20px', width: '200px', fontSize: 'medium', fontFamily: 'Quicksand'}}>Domain Authority</p>
            </BingSearchRes>
            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
              {data[0].siteRank && prevUrl.trim() !== '' && <h4 style={{fontWeight: '300', color: 'orangered', backgroundColor: 'rgba(255, 228, 177, 0.358)', width: '500px'}}>{data[0].siteRank}</h4>}
            {data[0]?.data.map(serp=> {
                return (
                    <>
                        <BingSearchRes key={serp.rank}>
                        <p style={{width: '20px', fontSize: 'medium'}}>{serp.rank}</p>
                        <div><div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}><img src={serp.img} onClick={()=> window.open(serp.url, '_blank')} style={{cursor: 'pointer'}}/><span style={{marginLeft: '7px', color: 'blue', cursor: 'pointer'}} onClick={()=> window.open(serp.url, '_blank')}>{serp.title}</span></div><span style={{color: 'green', fontSize: 'small', width: '700px', cursor: 'pointer', width: 'fit-content'}} onClick={()=> window.open(serp.url, '_blank')}>{serp.url}</span><span style={{color: 'gray', fontSize: 'small', width: '700px'}}>{serp.desc}</span></div>
                        <p style={{marginLeft: '70px', width: '200px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{serp.pa}</p>
                        <p style={{marginLeft: '30px', width: '200px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{serp.da}</p>
                        </BingSearchRes>
                    </>
                )
            })}
            </div>
        </BingSearchResContainer>}
        {isLoading && <Loading />}

        {noData && !isLoading && <BingSearchResContainer>
          <p style={{fontFamily: 'Quicksand', fontSize: 'larger', color: 'white', display: 'flex', alignItems: 'center', gap: '10px'}}>
            <SentimentVeryDissatisfiedIcon />
            We couldn't retrieve the data at the moment. Please try again later
          </p>  
        </BingSearchResContainer>}

        {data[0].data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Bing SERP Tool helps you analyze search engine results pages (SERP) specifically for Bing. 
            By entering a keyword and location, you can view the current SERP, including top-ranking pages, their metadata, and page authorities on Bing.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter a keyword in the search bar</p>
          <p>2. Select your target location</p>
          <p>3. Click "Get Data" to see detailed Bing search engine results and page information</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Review Bing SERP data to understand how different content ranks and find opportunities to enhance your Bing SEO strategy</p>

        </Intro>}
    </BingSearchContainer>
  )
}

export default BingSearch


const BingSearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`



const BingSearchInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > div > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--se-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--se-color);
    color: white;
  }

  > div > button:hover {
    color: var(--se-color);
    background-color: rgb(239, 239, 239);
  }
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const BingSearchInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const BingSearchResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const BingSearchRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);


    > div {
        display: flex;
        flex-direction: column;
        width: 700px;
        margin-left: 30px;
        margin-right: 20px;
    }
`

const HeaderSpan = styled.span`
    font-weight: 300;
    color: var(--se-color);
    font-size: medium;

    opacity: 0;
    animation: ${fadeInAnimation} 0.6s ease-in-out forwards;
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`